import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
@Component({
  selector: 'app-distribution-calculation',
  templateUrl: './distribution-calculation.component.html',
  styleUrls: ['./distribution-calculation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DistributionCalculationComponent implements OnInit {

  @Input() public calculationResponse: object;
  @Input() public toggleVal: string;
  @Input() public distributionColData: any = [];
  @Input() public selectedMonth: number;

  accordionId: any = 'pp-accordion-val';
  expanded: boolean = true;
  isTitleClickable: boolean = true;
  showArrow: boolean = true;
  showBorder: boolean = true;
  accordionSettings: {
    isDisable: false
    showHover: true
    showCursorNotAllowed: false
    iconPosition: "end"
  }
  calculationData: any = [];
  hiddenColumnLength = 0;
  isElegibleForProfitSharing: boolean = false;

  constructor() {
  }

  ngOnInit() {
    this.calculationData = [];
    let calculationDataHidden: any = [];
    if (this.calculationResponse[0]){
      this.isElegibleForProfitSharing = this.calculationResponse[0].isElegibleForProfitSharing
      if (this.toggleVal === 'Monthly') {
        this.distributionColData.forEach(distributionCol => {
          if (distributionCol.hidden) this.hiddenColumnLength++;
          let calculationDataObj = {};
          switch (distributionCol.value) {
            case "poolInPerOpDaysAmt":
              calculationDataObj = {
                'type': 'poolIn', //pool in per op days, pool out, net pool out per op days, 
                'headingName': distributionCol.name,
                'headingTitle': 'Pool in ($/per Op. day)',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['distAmt'],
                  'val2': this.calculationResponse[0]['opDays']
                }
              };
              break;
            case "relShare":
              calculationDataObj = {
                'type': 'relShare', //Relative Share in pool, 
                'headingName': distributionCol.name,
                'headingTitle': 'Relative share in pool',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD] * 100, //should show as % in UI
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['opDays'],
                  'val2': this.calculationResponse[0]['poolPoint'],
                  'val3': this.calculationResponse[0]['opDaysPoolPointSum'],
                }
              };
              break;
            case "grossDistribution":
              calculationDataObj = {
                'type': 'grossDistribution', //grossDistribution, 
                'headingName': distributionCol.name,
                'headingTitle': 'Gross distribution',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['distAmtSum'],
                  'val2': this.calculationResponse[0]['subpoolsMonthlyData'][0]['accountingVoyageMonthly'],
                  'val3': this.calculationResponse[0]['subpoolsMonthlyData'][0]['scrubberSavingsMonthly'],
                  'val4': this.calculationResponse[0]['subpoolsMonthlyData'][0]['lngSavingsYTD'],
                  'val5': this.calculationResponse[0]['relShareYTD'] * 100, //should show as % in UI
                  'val6': this.calculationResponse[0]['subPool'],
                }
              };
              break;
            case "poolOut":
              calculationDataObj = {
                'type': 'poolIn', //pool in per op days, pool out, net pool out per op days, 
                'headingName': distributionCol.name,
                'headingTitle': 'Pool out',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['grossShareInPoolAmt'],
                  'val2': this.calculationResponse[0]['opDays']
                }
              };
              break;
            case "overheadFee":
              calculationDataObj = {
                'type': 'overheadFee', //overheadFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Overhead fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['subpoolsMonthlyData'][0]['subpoolName'],
                  'val2': this.calculationResponse[0]['subpoolsMonthlyData'][0]['overheadCharges'],
                  'val3': this.calculationResponse[0]['opDaysData'][0]['calendarDaysMonthly']
                }
              };
              break;
            case "commissionFee":
              calculationDataObj = {
                'type': 'commissionFee', //commissionFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Commission fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['fleetsData'][0]['commissionPercentage'] * 100, //should show as % in UI
                  'val2': this.calculationResponse[0]['revenueAmtSum'],
                  'val3': this.calculationResponse[0]['relShareYTD'] * 100, //should show as % in UI
                  'val4': this.calculationResponse[0]['subpoolsMonthlyData'][0]['subpoolName']
                }
              };
              break;
            case "bunkerFee":
              calculationDataObj = {              
                'type': 'bunkerFee', //bunkerFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Bunker procurement fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['BFBMonthly'] : 0,
                  'val2': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['BFB'],
                  'val3': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['IFOMonthly'] : 0,
                  'val4': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['IFO'],
                  'val5': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['LSFMonthly'] : 0,
                  'val6': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['LSF'],
                  'val7': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['MGOMonthly'] : 0,
                  'val8': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['MGO'],
                }
              };
              break;
            case "managementFee":
              calculationDataObj = {
                'type': 'managementFee', //managementFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Management fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['overheadAmt'],
                  'val2': this.calculationResponse[0]['commissionAmt'],
                  'val3': this.calculationResponse[0]['bunkerAmt']
                }
              };
              break;
            case "netPoolOut":
              calculationDataObj = {
                'type': 'netPoolOut', //netPoolOut, 
                'headingName': distributionCol.name,
                'headingTitle': 'Net pool out',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['grossShareInPoolAmt'],
                  'val2': this.calculationResponse[0]['mgmtFees']
                }
              };
              break;
            case "netPoolOutPerOpDaysAmt":
              calculationDataObj = {
                'type': 'poolIn', //pool in per op days, pool out, net pool out per op days, 
                'headingName': distributionCol.name,
                'headingTitle': 'Net pool out ($/per Op. day)',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['netPoolOut'],
                  'val2': this.calculationResponse[0]['opDays']
                }
              };
              break;
            case "profitShare":
              calculationDataObj = {
                'type': 'profitShare', //profitShare, 
                'headingName': distributionCol.name,
                'headingTitle': 'Profit sharing',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['netPoolOutPerOpdaysAmt'],
                  'val2': this.calculationResponse[0]['profitSharingThresholdAmt'],
                  'val3': this.calculationResponse[0]['profitSharingRate'] * 100, //should show as % in UI
                  'val4': this.calculationResponse[0]['opDays']
                }
              };
              break;
            case "finalPayout": //only visible in monthly view
              let scrubberLng = 'N/A'
              if(this.calculationResponse[0]['vessels'][0]['scrubberType'] > 0 || this.calculationResponse[0]['vessels'][0]['lng'] > 0){
                scrubberLng = this.calculationResponse[0]['scbrSavingsAmt'] + this.calculationResponse[0]['lngSavingsAmt']
              }
              calculationDataObj = {
                'type': 'finalPayout', //finalPayout, 
                'headingName': distributionCol.name,
                'headingTitle': 'Final payout',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['netPoolOut'],
                  'val2': this.calculationResponse[0]['profitSharingContrAmt'],
                  'val3': scrubberLng
                }
              };
              break;        
          }

          if(calculationDataObj['type']){ // dont add for empty obj
            calculationDataObj['hidden'] = distributionCol.hidden;
            if(distributionCol.hidden){
              calculationDataHidden.push(calculationDataObj)
            }
            else{
              this.calculationData.push(calculationDataObj)
            } 
          }               
        });
      }
      else {
        this.distributionColData.forEach(distributionCol => {
          if (distributionCol.hidden) this.hiddenColumnLength++;
          let calculationDataObj = {};
          switch (distributionCol.value) {
            case "poolInPerOpDaysAmt":
              calculationDataObj = {
                'type': 'poolIn', //pool in per op days, pool out, net pool out per op days, 
                'headingName': distributionCol.name,
                'headingTitle': 'Pool in ($/per Op. day)',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['distAmtYTD'],
                  'val2': this.calculationResponse[0]['opDaysYTD']
                }
              };
              break;
            case "relShare":
              calculationDataObj = {
                'type': 'relShare', //Relative Share in pool, 
                'headingName': distributionCol.name,
                'headingTitle': 'Relative share in pool',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD] * 100, //should show as % in UI
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['opDaysYTD'],
                  'val2': this.calculationResponse[0]['poolPoint'],
                  'val3': this.calculationResponse[0]['opDaysPoolPointYTDSum'],
                }
              };
              break;
            case "grossDistribution":
              calculationDataObj = {
                'type': 'grossDistribution', //grossDistribution, 
                'headingName': distributionCol.name,
                'headingTitle': 'Gross distribution',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['distAmtYTDSum'],
                  'val2': this.calculationResponse[0]['subpoolsMonthlyData'][0]['accountingVoyage'],
                  'val3': this.calculationResponse[0]['subpoolsMonthlyData'][0]['scrubberSavings'],
                  'val4': this.calculationResponse[0]['subpoolsMonthlyData'][0]['lngSavingsYTD'],
                  'val5': this.calculationResponse[0]['relShareYTD'] * 100, //should show as % in UI
                  'val6': this.calculationResponse[0]['subPool'],
                }
              };
              break;
            case "poolOut":
              calculationDataObj = {
                'type': 'poolIn', //pool in per op days, pool out, net pool out per op days, 
                'headingName': distributionCol.name,
                'headingTitle': 'Pool out',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['grossShareInPool'],
                  'val2': this.calculationResponse[0]['opDaysYTD']
                }
              };
              break;
            case "overheadFee":
              calculationDataObj = {
                'type': 'overheadFee', //overheadFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Overhead fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['subpoolsMonthlyData'][0]['subpoolName'],
                  'val2': this.calculationResponse[0]['subpoolsMonthlyData'][0]['overheadCharges'],
                  'val3': this.calculationResponse[0]['opDaysData'][0]['calendarDays']
                }
              };
              break;
            case "commissionFee":
              calculationDataObj = {
                'type': 'commissionFee', //commissionFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Commission fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['fleetsData'][0]['commissionPercentage'] * 100, //should show as % in UI
                  'val2': this.calculationResponse[0]['revenueAmtYTDSum'],
                  'val3': this.calculationResponse[0]['relShareYTD'] * 100, //should show as % in UI,
                  'val4': this.calculationResponse[0]['subpoolsMonthlyData'][0]['subpoolName']
                }
              };
              break;
            case "bunkerFee":
              calculationDataObj = {
                'type': 'bunkerFee', //bunkerFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Bunker procurement fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['BFB'] : 0,
                  'val2': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['BFB'],
                  'val3': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['IFO'] : 0,
                  'val4': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['IFO'],
                  'val5': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['LSF'] : 0,
                  'val6': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['LSF'],
                  'val7': this.calculationResponse[0]['bunkerMonthlyData'].length > 0 ? this.calculationResponse[0]['bunkerMonthlyData'][0]['MGO'] : 0,
                  'val8': this.calculationResponse[0]['ownersData'][0]['bunkerProcurementFee']['MGO'],
                }
              };
              break;
            case "managementFee":
              calculationDataObj = {
                'type': 'managementFee', //managementFee, 
                'headingName': distributionCol.name,
                'headingTitle': 'Management fee',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['overheadAmtYTD'],
                  'val2': this.calculationResponse[0]['commissionAmtYTD'],
                  'val3': this.calculationResponse[0]['bunkerYTD']
                }
              };
              break;
            case "netPoolOut":
              calculationDataObj = {
                'type': 'netPoolOut', //netPoolOut, 
                'headingName': distributionCol.name,
                'headingTitle': 'Net pool out',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['grossShareInPool'], // Gross distribution
                  'val2': this.calculationResponse[0]['mgmtFeesYTD']
                }
              };
              break;
            case "netPoolOutPerOpDaysAmt":
              calculationDataObj = {
                'type': 'poolIn', //pool in per op days, pool out, net pool out per op days, 
                'headingName': distributionCol.name,
                'headingTitle': 'Net pool out ($/per Op. day)',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['netPoolOutYTD'],
                  'val2': this.calculationResponse[0]['opDaysYTD']
                }
              };
              break;
            case "profitShare":
              calculationDataObj = {
                'type': 'profitShare', //profitShare, 
                'headingName': distributionCol.name,
                'headingTitle': 'Profit sharing',
                'headingValue': this.calculationResponse[0][distributionCol.colHeaderYTD],
                'formulaText': distributionCol.value,
                'formulaValues': {
                  'val1': this.calculationResponse[0]['netPoolOutPerOpdaysAmtYTD'],
                  'val2': this.calculationResponse[0]['profitSharingThresholdAmt'],
                  'val3': this.calculationResponse[0]['profitSharingRate'] * 100, //should show as % in UI
                  'val4': this.calculationResponse[0]['opDaysYTD']
                }
              };
              break;        
          }

          if(calculationDataObj['type']){ // dont add for empty obj
            calculationDataObj['hidden'] = distributionCol.hidden;
            if(distributionCol.hidden){
              calculationDataHidden.push(calculationDataObj)
            }
            else{
              this.calculationData.push(calculationDataObj)
            }
          }
        });
      }

      if(calculationDataHidden.length > 0){ //set flag for first data only to show in html
        Object.assign(calculationDataHidden[0], { showHiddenMsg: true });
      }    
      this.calculationData.push(...calculationDataHidden);
    }
  }
}